<template>
  <section class="title-bed">
    <div :class="[isDefaultColor && 'default-color' , 'title-box']">
      <div class="title-back"
           @click="goBack">
        <img src="../assets/img/noAccess/btn_back.png"
             alt="">
      </div>
      <div class="title-more"
           @click="showMore">
        <img src="../assets/img/noAccess/icon_more.png"
             alt="">
      </div>
      {{ title }}
    </div>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default () {
        return ''
      }
    },
    isDefaultColor: {
      type: Boolean,
      default () {
        return false
      }
    },
    returnRouter: {
      type: Function,
      default () {
        return this.$router.go(-1)
      }
    },
    canGoHome: {//回到app
      type: Boolean,
      default () {
        return false
      }
    },
    showMore: {
      type: Function,
      default () {
        return null
      }
    }
  },
  mounted () {
    const that = this;
    window.backToHome = that.backToHome; // 挂载到window中
  },
  methods: {
    goBack () {
      if(this.canGoHome) {
        window.android.backToHome(true)
      }else {
        this.returnRouter()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.title-box {
  position: relative;
  color: #fff;
  font-size: 32px;
  padding: 20px 15px;
  box-sizing: border-box;
  height: 88px;
  font-weight: 500;
  text-align: center;
  &.default-color {
    background: $themeColor;
  }
  .title-back {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 20px;
    padding: 20px 5px;
    img {
      height: 100%;
    }
    .back-hidden {
      display: none;
    }
    .back {
      display: block;
    }
  }
  .title-more {
    position: absolute;
    right: 40px;
    top: 0;
    padding: 20px 5px;
    img {
      width: 44px;
      height: 100%;
    }
  }
}
</style>
